import React, { useCallback, useEffect, useState } from 'react';
import useFetch from '../../hooks/useFetch';
import MainLayout from '../../layouts/MainLayout';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faInstagram, faLinkedin, faTwitter } from '@fortawesome/free-brands-svg-icons';
import logo from '../../assets/logo.png';
import profileImage from '../../assets/cards/kidprofile.png';

import "../../styles/MyProfile.css";
import { faBriefcaseClock } from '@fortawesome/free-solid-svg-icons';
import QRCode from 'react-qr-code';
import bgImage from '../../assets/cards/panda.png';  // Add a panda image here

const MyDigitalCardChildren = () => {
  const authState = useSelector(state => state.authReducer);
  const [fetchData] = useFetch();
  const userId = authState.user._id;
  const userCode = authState.user.think5whysCode;
  const userName = authState.user.name;

  const [profileData, setProfileData] = useState({
    userId: authState.user._id,
    name: authState.user.name,
    gender: 0,
    dob: '',
    email: authState.user.email,
    mobile: '',
    city: '',
    institution: '',
    socialLinks: '',
    personalPageLink: '',
    think5whysCode: authState.user.think5whyscode,
    image: '',
  });

  const [profileExists, setProfileExists] = useState(false);
  const [profileId, setProfileId] = useState('');
  const [loading, setLoading] = useState(true);
  const [createSuccessMsg, setCreateSuccessMsg] = useState('');

  useEffect(() => {
    fetchUserProfile(userId);
  }, [userId]);

  const fetchUserProfile = useCallback(() => {
    const config = {
      url: "/myprofile/byid",
      method: 'post',
      data: { userId: userId },
      headers: { Authorization: authState.token },
    };
    fetchData(config)
      .then(response => {
        if (response && response.status) {
          setProfileExists(true);
          const { profile } = response;
          setProfileId(profile._id);
          setProfileData({
            userId: profile.userId,
            name: profile.name,
            gender: profile.gender,
            dob: profile.dob,
            email: profile.email,
            mobile: profile.mobile,
            city: profile.city,
            institution: profile.institution,
            socialLinks: profile.socialLinks,
            personalPageLink: profile.personalPageLink,
            think5whysCode: profile.think5whysCode,
          });
        } else {
          setCreateSuccessMsg("Sorry! Profile Not Found. Please retry.");
        }
      })
      .catch(error => {
        console.error("Error getting profile:", error);
        setCreateSuccessMsg("Sorry! Profile Not Found. Please retry.");
      });
  }, [userId, fetchData, authState.token]);

  return (
      <div className="flex flex-col justify-center items-center p-4 relative">
        <div className="relative z-10 w-full max-w-lg p-6 rounded-lg shadow-lg"
             style={{ 
               backgroundImage: `url(${bgImage})`, 
               backgroundSize: 'cover', 
               backgroundPosition: 'center', 
               backgroundColor: 'rgba(255, 255, 255, 0.3)', 
               borderRadius: '10px',
               border: '2px solid #FFD700' 
             }}>
          <div className="flex justify-between items-start mb-4">
            <h2 className="text-purple-700 font-extrabold text-5xl">{profileData.name}</h2>
            {/* <img
              src={profileData.image || profileImage}
              alt="Profile"
              className="w-32 h-32 rounded-full border-4 border-yellow-400"
            /> */}
            <img 
              src={
                `/api/downloads/users/profilepic/${profileData.think5whysCode}.png` || 
                `/api/downloads/users/profilepic/noprofilepic.png`
              }
              alt="Profile Pic" 
              className="w-32 h-32 rounded-full border-4 border-yellow-400"
            />
          </div>
          <div className="text-center">
            <p className="text-lg text-yellow-300 mb-1">ID#: {profileData.think5whysCode}</p>
            <p className="text-lg text-yellow-300 mb-1">My Loving Parents</p>
            <p className="text-lg text-yellow-300 mb-1">.....</p>
            <p className="text-lg text-yellow-300 mb-1">School: {profileData.institution}</p>
            <p className="text-lg text-yellow-300 mb-4">Place: {profileData.city}</p>
          </div>
          <div className="flex justify-around mb-4">
            <a href={profileData.socialLinks?.facebook} target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon className="text-blue-600" icon={faFacebook} size="lg" />
            </a>
            <a href={profileData.socialLinks?.instagram} target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon className="text-pink-600" icon={faInstagram} size="lg" />
            </a>
            <a href={profileData.socialLinks?.twitter} target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon className="text-blue-400" icon={faTwitter} size="lg" />
            </a>
            <a href={profileData.personalPageLink} target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon className="text-blue-700" icon={faLinkedin} size="lg" />
            </a>
            <a href={profileData.personalPageLink} target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon className="text-gray-600" icon={faBriefcaseClock} size="lg" />
            </a>
          </div>
          <p className="bg-yellow-300 text-blue-800 text-center text-lg py-2 rounded-md">
            Powered by
            <img
              src={logo}
              alt="Think5Whys"
              className="inline-block w-6 h-6 mx-2"
            />
            think5whys.com
          </p>
        </div>
        <div className="bg-gradient-to-r from-green-300 to-blue-300 border-4 border-pink-500 rounded-lg mt-8 p-4 w-full max-w-sm flex flex-col justify-center items-center relative z-10">
          <QRCode value={"https://www.think5whys.com/user?"+userCode+"/"+userName} size={128} className="bg-white p-2 rounded-md shadow-md" />
          <p className="text-gray-800 text-xs mt-2">
            My Card powered by <span className="font-bold">Think5Whys</span>
          </p>
        </div>
      </div>
  );
};

export default MyDigitalCardChildren;
